import React from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../../content/homeMarketing";
import "../Home.css";

export default function DownloadAppSection({ t, lang }) {
  return (
    <>
      <div className="section-wave" aria-hidden="true" />
      <section className="download-app-section scroll-animate from-right" aria-labelledby="download-title">
        <div className={`download-app-inner container ${lang === "ar" ? "rtl" : ""}`}>
          <div className="download-app-phone scroll-animate from-bottom delay-1" aria-hidden="true">
            <svg className="download-phone-art" viewBox="0 0 220 260" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M34 42 L18 28 M40 34 L26 20 M46 26 L34 12" stroke="#18442A" strokeWidth="5" strokeLinecap="round" />
              <g transform="rotate(-14 112 132)">
                <rect x="52" y="36" width="120" height="196" rx="22" fill="#18442A" stroke="#0e1726" strokeWidth="6" />
                <rect x="66" y="58" width="92" height="148" rx="10" fill="#F3EDE3" />
                <rect x="88" y="46" width="44" height="6" rx="3" fill="#0e1726" />
                <path
                  d="M112 118 C98 102 82 112 82 128 C82 148 112 168 112 168 C112 168 142 148 142 128 C142 112 126 102 112 118Z"
                  fill="#18442A"
                />
              </g>
            </svg>
          </div>
          <div className="download-app-body">
            <div className="download-app-copy">
              <h2 id="download-title" className="download-title scroll-animate from-right delay-2">
                {t.downloadTitle}
              </h2>
              <p className="download-subtitle scroll-animate from-right delay-2">{t.downloadSubtitle}</p>
            </div>
            <div className="download-buttons scroll-animate from-right delay-3">
              <a
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn google-play"
                aria-label="Get it on Google Play"
              >
                <div className="download-btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M3.609 1.814L13.792 12L3.609 22.186Z" fill="#EA4335" />
                    <path d="M3.609 1.814L13.792 12L17.969 7.824L6.239 1.548C5.156 0.955 3.609 1.814 3.609 1.814Z" fill="#FBBC04" />
                    <path d="M3.609 22.186L13.792 12L17.969 16.176L6.239 22.452C5.156 23.045 3.609 22.186 3.609 22.186Z" fill="#34A853" />
                    <path d="M13.792 12L17.969 7.824L21.035 9.534C22.092 10.135 22.092 11.865 21.035 12.466L17.969 16.176L13.792 12Z" fill="#4285F4" />
                  </svg>
                </div>
                <div className="download-btn-text">
                  <span className="download-btn-small">GET IT ON</span>
                  <span className="download-btn-large">Google Play</span>
                </div>
              </a>
              <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="download-btn app-store"
                aria-label="Download on the App Store"
              >
                <div className="download-btn-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path
                      d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
                      fill="currentColor"
                    />
                  </svg>
                </div>
                <div className="download-btn-text">
                  <span className="download-btn-small">Download on the</span>
                  <span className="download-btn-large">App Store</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="section-wave section-wave--white" aria-hidden="true" />
    </>
  );
}
